import React from 'react';
import { FileText, AlertCircle, CheckCircle, Clock, ExternalLink } from 'lucide-react';
export function LicenseInformation() {
  return <div className="min-h-screen bg-white pt-40 lg:pt-52 pb-20" data-id="element-662">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-663">
        {/* Page Header */}
        <div className="mb-12" data-id="element-664">
          <div className="flex items-center justify-center mb-6" data-id="element-665">
            <FileText className="w-12 h-12 text-brand-purple-600 mr-4" data-id="element-666" />
            <h1 className="text-4xl font-bold text-gray-900" data-id="element-667">
              License Information
            </h1>
          </div>
        </div>

        {/* Quick Links */}
        <div className="mb-12 bg-brand-purple-50 rounded-lg p-6 border-2 border-brand-purple-200" data-id="element-668">
          <p className="text-lg text-gray-900 mb-4" data-id="element-669">
            <strong data-id="element-670">License and Course Information:</strong>{' '}
            <a href="/Products" className="text-brand-purple-600 hover:text-brand-purple-700 font-semibold underline" data-id="element-671">
              Click here to see On-Demand class offerings
            </a>{' '}
            or{' '}
            <a href="/Login" className="text-brand-purple-600 hover:text-brand-purple-700 font-semibold underline" data-id="element-672">
              Log In
            </a>
          </p>
        </div>

        {/* Key Information Bullets */}
        <div className="mb-12 space-y-4" data-id="element-673">
          <div className="flex items-start" data-id="element-674">
            <CheckCircle className="w-6 h-6 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-675" />
            <p className="text-base text-gray-700" data-id="element-676">
              All classes are approved for renewal credit with the Arizona
              Department of Real Estate School #S06-0002
            </p>
          </div>
          <div className="flex items-start" data-id="element-677">
            <CheckCircle className="w-6 h-6 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-678" />
            <p className="text-base text-gray-700" data-id="element-679">
              Our classes are text-based so there is no need to worry about
              audio or video issues.
            </p>
          </div>
          <div className="flex items-start" data-id="element-680">
            <CheckCircle className="w-6 h-6 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-681" />
            <p className="text-base text-gray-700" data-id="element-682">
              The final exam will repeat the quiz questions and you will need to
              achieve at least 80% correct to pass.
            </p>
          </div>
          <div className="flex items-start" data-id="element-683">
            <CheckCircle className="w-6 h-6 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-684" />
            <p className="text-base text-gray-700" data-id="element-685">
              When a class is completed you can print your certificate
              immediately from your Class History folder on your Dashboard.
            </p>
          </div>
          <div className="flex items-start" data-id="element-686">
            <CheckCircle className="w-6 h-6 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-687" />
            <p className="text-base text-gray-700" data-id="element-688">
              To be paperless when you click to print your certificate, a PDF
              will be downloaded to your computer. Save in a folder to retrieve
              class information.
            </p>
          </div>
        </div>

        {/* Salesperson Requirements */}
        <div className="mb-12 bg-white rounded-lg border-2 border-gray-200 p-8" data-id="element-689">
          <h2 className="text-2xl font-bold text-brand-purple-900 mb-6" data-id="element-690">
            Salesperson
          </h2>
          <p className="text-lg font-semibold text-gray-900 mb-4" data-id="element-691">
            24 credit hours required every two years, with at least one class of
            each of the following credit type, plus 1 class for elective credit:
          </p>
          <ul className="space-y-2 mb-6" data-id="element-692">
            <li className="flex items-start" data-id="element-693">
              <span className="text-brand-purple-600 mr-2" data-id="element-694">*</span>
              <span className="text-base text-gray-700" data-id="element-695">Agency Law</span>
            </li>
            <li className="flex items-start" data-id="element-696">
              <span className="text-brand-purple-600 mr-2" data-id="element-697">*</span>
              <span className="text-base text-gray-700" data-id="element-698">Contract Law</span>
            </li>
            <li className="flex items-start" data-id="element-699">
              <span className="text-brand-purple-600 mr-2" data-id="element-700">*</span>
              <span className="text-base text-gray-700" data-id="element-701">Disclosure</span>
            </li>
            <li className="flex items-start" data-id="element-702">
              <span className="text-brand-purple-600 mr-2" data-id="element-703">*</span>
              <span className="text-base text-gray-700" data-id="element-704">Fair Housing</span>
            </li>
            <li className="flex items-start" data-id="element-705">
              <span className="text-brand-purple-600 mr-2" data-id="element-706">*</span>
              <span className="text-base text-gray-700" data-id="element-707">
                General - Deed Fraud, Firewise + AZ Water
              </span>
            </li>
            <li className="flex items-start" data-id="element-708">
              <span className="text-brand-purple-600 mr-2" data-id="element-709">*</span>
              <span className="text-base text-gray-700" data-id="element-710">Legal Issues</span>
            </li>
            <li className="flex items-start" data-id="element-711">
              <span className="text-brand-purple-600 mr-2" data-id="element-712">*</span>
              <span className="text-base text-gray-700" data-id="element-713">
                Requirements for Licensees (formerly Commissioner's Standards)
              </span>
            </li>
          </ul>
          <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded" data-id="element-714">
            <p className="text-base text-gray-800" data-id="element-715">
              <strong data-id="element-716">1 class (3 hours) for elective credit</strong> - You may
              choose any credit type, providing you do not duplicate any course
              title you have already taken within that renewal period.
            </p>
          </div>
        </div>

        {/* Broker Requirements */}
        <div className="mb-12 bg-white rounded-lg border-2 border-gray-200 p-8" data-id="element-717">
          <h2 className="text-2xl font-bold text-brand-purple-900 mb-6" data-id="element-718">
            Designated Broker, Self Employed Broker and Associate Broker in a
            supervisory role
          </h2>
          <p className="text-lg font-semibold text-gray-900 mb-4" data-id="element-719">
            30 credit hours required every 2 years.
          </p>
          <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded" data-id="element-720">
            <p className="text-base text-gray-800 mb-3" data-id="element-721">
              The BMC Package includes all required courses plus Broker
              Management Clinic #1, #2, #3 for 30 hours
            </p>
            <p className="text-base text-gray-800" data-id="element-722">
              If your brokerage does property management, choose the Broker
              Package with BMC3B
            </p>
          </div>
        </div>

        {/* Timer Notice */}
        <div className="mb-12 bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-lg" data-id="element-723">
          <div className="flex items-start" data-id="element-724">
            <Clock className="w-6 h-6 text-yellow-600 mr-3 mt-1 flex-shrink-0" data-id="element-725" />
            <div data-id="element-726">
              <p className="text-base text-gray-800 mb-3" data-id="element-727">
                <strong data-id="element-728">NOTE:</strong> ADRE is requiring ALL credit hour classes
                (in-person and distance learning) to be timed for a total of 150
                minutes. To be compliant with ADRE rules, all of our On-Demand
                Platform classes have a timer.
              </p>
              <p className="text-base text-gray-800" data-id="element-729">
                As long as your class is open and your browser is running, the
                timer will continue to count down. If you click on another link,
                close your browser or shut off your computer while in a class,
                the timer will stop at that point and will begin at the spot you
                left off when you come back and click on the class title. If you
                are finished early, you can walk away and let the timer continue
                counting down to 0, as long as your device does not go to sleep
                and disconnects from the server.
              </p>
            </div>
          </div>
        </div>

        {/* Renewal Requirements */}
        <div className="mb-12 bg-white rounded-lg border-2 border-gray-200 p-8" data-id="element-730">
          <h2 className="text-2xl font-bold text-brand-purple-900 mb-6" data-id="element-731">
            Arizona Real Estate License Renewal Requirements
          </h2>
          <p className="text-base text-gray-700 mb-6" data-id="element-732">
            Complete hours of renewal credit (24 or 30) through any approved
            Real Estate school, within the 2 year period of the current license.
          </p>

          <div className="space-y-6" data-id="element-733">
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-734">
              <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-735">
                The Salesperson - 24 hours
              </h3>
              <p className="text-base text-gray-700 mb-3" data-id="element-736">
                Must include 21 hours in the 7 required class types. The last 3
                hours is your Elective and can be any class type you want*
              </p>
              <p className="text-sm text-gray-600 italic" data-id="element-737">
                Note: Additional General classes are accepted as elective credit
                ONLY
              </p>
              <p className="text-sm text-gray-600 italic mt-2" data-id="element-738">
                *While you may duplicate a course type to complete your 24
                hours, you may not duplicate a course number already taken
                during that renewal period. Different class name=Different
                course number
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-739">
              <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-740">
                Designated Brokers (and Supervisory Associate Brokers) - 30
                hours
              </h3>
              <p className="text-base text-gray-700" data-id="element-741">
                Must include 9 hours BMC (Requirements for Licensees) and the
                balance of 21 hours are the 6 other required classes and 1
                elective credit in any course type* you desire.
              </p>
            </div>
          </div>
        </div>

        {/* Important Notes */}
        <div className="mb-12 space-y-6" data-id="element-742">
          <div className="bg-blue-50 border-l-4 border-blue-400 p-6 rounded-lg" data-id="element-743">
            <p className="text-base text-gray-800" data-id="element-744">
              You may pay for and renew your license up to 90 days prior to
              expiration
            </p>
          </div>

          <div className="bg-brand-purple-50 border-l-4 border-brand-purple-400 p-6 rounded-lg" data-id="element-745">
            <p className="text-base text-gray-800 mb-3" data-id="element-746">
              <strong data-id="element-747">NOTE:</strong> The Arizona Department of Real Estate
              (ADRE) is urging you to renew your real estate license online and
              offers a discounted cost for doing so.
            </p>
            <p className="text-base text-gray-800" data-id="element-748">
              Fee Schedule Link:{' '}
              <a href="https://azre.gov/all-adre-resources/fees" target="_blank" rel="noopener noreferrer" className="text-brand-purple-600 hover:text-brand-purple-700 font-semibold underline inline-flex items-center" data-id="element-749">
                https://azre.gov/all-adre-resources/fees
                <ExternalLink className="w-4 h-4 ml-1" data-id="element-750" />
              </a>
            </p>
          </div>

          <div className="bg-red-50 border-l-4 border-red-400 p-6 rounded-lg" data-id="element-751">
            <div className="flex items-start" data-id="element-752">
              <AlertCircle className="w-6 h-6 text-red-600 mr-3 mt-1 flex-shrink-0" data-id="element-753" />
              <p className="text-base text-gray-800" data-id="element-754">
                You must complete and report all of your CE credits by midnight
                of the calender day of the month that your license expires (that
                includes Saturdays, Sundays and Holidays). Log on at{' '}
                <a href="https://ptl.az.gov/dre/#/login" target="_blank" rel="noopener noreferrer" className="text-brand-purple-600 hover:text-brand-purple-700 font-semibold underline" data-id="element-755">
                  https://ptl.az.gov/dre/#/login
                </a>{' '}
                and have your credit card ready along with all of your
                certificates for classes attended.
              </p>
            </div>
          </div>
        </div>

        {/* Contact CTA */}
        <div className="bg-brand-purple-50 rounded-lg p-8 text-center border border-brand-purple-100" data-id="element-756">
          <h2 className="text-2xl font-bold text-brand-purple-900 mb-4" data-id="element-757">
            Have Questions?
          </h2>
          <p className="text-gray-700 mb-6" data-id="element-758">
            Our team is here to help you navigate your license renewal
            requirements.
          </p>
          <a href="/Contact" className="inline-flex items-center px-8 py-3 bg-brand-purple-600 text-white font-bold rounded-md hover:bg-brand-purple-700 transition-colors" data-id="element-759">
            Contact Us
          </a>
        </div>
      </div>
    </div>;
}